import { Box, Button, Grid, Modal } from '@mui/material'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'
export default function ModalDelete({
    open,
    setOpen,
    onSubmit,
    message,
    disabled,
}) {
    return (
        <Modal open={open} onClose={() => setOpen(false)}>
            <Box
                sx={{
                    position: 'absolute',
                    width: 320,
                    bgcolor: 'background.paper',
                    boxShadow: 6,
                    padding: '25px 20px',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    borderRadius: '8px',
                }}
            >
                <Grid container spacing={0}>
                    <Grid item xs={12} align='center'>
                        <CancelOutlinedIcon
                            color='error'
                            fontSize='large'
                            sx={{ width: '50px', height: '50px' }}
                        />
                    </Grid>
                    <Grid item xs={12} align='center'>
                        <Box sx={{ fontWeight: 'bold', fontSize: '18px' }}>
                            Are you sure?
                        </Box>
                    </Grid>
                    <Grid item xs={12} align='center' mt={0}>
                        <Box sx={{ fontSize: '16px' }}>
                            Do you really want to delete "{message}"
                        </Box>
                    </Grid>

                    <Grid item xs={12} align='center' mt={1.5} mb={0}>
                        <Button
                            disabled={disabled}
                            color='error'
                            sx={{ color: 'white', textTransform: 'none' }}
                            variant='contained'
                            onClick={() => onSubmit()}
                        >
                            Delete
                        </Button>
                        <Button
                            color='secondary'
                            onClick={() => setOpen(false)}
                            sx={{
                                color: 'white',
                                textTransform: 'none',
                                background: 'lightgrey',
                                marginLeft: '10px',
                            }}
                            variant='contained'
                        >
                            Cancel
                        </Button>
                    </Grid>
                </Grid>
            </Box>
        </Modal>
    )
}
